<template>
  <div class="special_content">
    <!--搜索头部-->
    <div class="special_content_head">
      <el-form
        class="search_form"
        ref="specialSearch"
        :model="searchForm"
        :inline="true"
      >
        <div>
          <el-form-item label="地区:" prop="areaId">
            <el-cascader
              :options="districtOptions"
              popper-class="sel-area-cascader"
              v-model="searchForm.areaId"
              style="width: 220rem"
              clearable
              :props="{ expandTrigger: 'hover' }"
              placeholder="全部"
            >
            </el-cascader>
          </el-form-item>
          <el-form-item label="题源:" prop="bookType">
            <el-select
              v-model="searchForm.bookType"
              style="width: 220rem"
              placeholder="全部"
              popper-class="select-popper"
              clearable
            >
              <el-option
                v-for="item in questionList"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="模块:" prop="catalogType">
            <el-select
              v-model="searchForm.catalogType"
              style="width: 220rem"
              placeholder="全部"
              popper-class="select-popper"
              clearable
            >
              <el-option
                v-for="item in catalogList"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button plain @click="search" class="search">搜索</el-button>
          </el-form-item>
          <el-form-item>
            <el-button plain @click="resetSearchForm" class="reset"
              >重置</el-button
            >
          </el-form-item>
        </div>
        <div>
          <el-form-item>
            <el-button
              icon="el-icon-circle-plus-outline"
              plain
              @click="areaVisible = true;"
              class="create_area"
              >创建地区</el-button
            >
          </el-form-item>
        </div>
      </el-form>
    </div>

    <!--各省听说专项-->
    <div class="special_body">
      <specialItem
        v-for="(item,index) in specialList"
        :specialItem="item"
        :key="index"
        class="specialItem"
        :filterArr="filterArr"
        @initAfterEdit="initAfterEdit"
        @updateRegionData="updateRegionData"
      ></specialItem>
      <el-empty
        description=" "
        :image-size="300"
        :image="require('./static/empty.png')"
        v-if="false"
      ></el-empty>
    </div>

    <!--创建地区对话框-->
    <el-dialog :visible.sync="areaVisible" width="380rem" class="areaDia" :before-close="closeDialog">
      <div slot="title">
        <div class="dia-title">
          <div class="dia-title-before"></div>
          <div class="dia-title-text">创建地区</div>
        </div>
      </div>
      <div class="area-content">
        <span class="red-star-icon">*</span>
        <p>地区：</p>
        <el-cascader
          :options="filterArr"
          v-model="districtForm.areaId"
          clearable
          :props="{ expandTrigger: 'hover' }"
          placeholder="请选择地区"
        >
        </el-cascader>
      </div>
      <div class="area-content" style="padding-left: 13rem">
        <p>启用：</p>
        <el-switch
          v-model="districtForm.status"
          active-color="#0BAE6A"
          inactive-color="#eeeeee"
        >
        </el-switch>
      </div>
      <div
        class="save-button"
        :class="{ 'diable-btn': btnDisabled }"
        @click="createDistrict"
      >
        确定
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getDistrictOpt,
  getQuestionSourceOpt,
  getCatalogOpt,
  searchOpt,
  addOrEditDistrict
} from "@/api/special";
import specialItem from "./components/specialItem";
import _ from "lodash";
export default {
  components: {
    specialItem,
  },
  watch: {
    districtForm: {
      handler(val) {
        if (val.areaId.length > 0) {
          this.btnDisabled = false;
        } else {
          this.btnDisabled = true;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      filterArr: [],
      districtOptions: [],
      specialList: [],
      questionList: [],
      catalogList: [],
      areaId: "",
      areaVisible: false,
      isEmpty: false,
      btnDisabled: false,
      districtForm: {
        areaId: 0,
        status: true,
      },
      searchForm: {
        areaId: 0,
        bookType: "",
        catalogType: "",
      },
    };
  },
  mounted() {
    //初始化数据
    this.init();
  },
  methods: {
    init() {
      //获取地区列表
      this.getDistrict();
      //获取试题来源
      this.getQuestionSource();
      //获取模块列表
      this.getCatalog();
      //获取数据
      this.search();
    },

    getDistrict() {
      getDistrictOpt().then((res) => {
        this.districtOptions = this.getDistrictRes(res);
        this.filterOptions(this.districtOptions);
      });
    },

    getQuestionSource() {
      getQuestionSourceOpt().then((res) => {
        if (res.code == 0 && res.data.length > 0) {
          this.questionList = res.data;
        }
      });
    },

    getCatalog() {
      getCatalogOpt().then((res) => {
        console.log("getCatalogOpt", res);
        if (res.code == 0 && res.data.length > 0) {
          this.catalogList = res.data;
        }
      });
    },

    filterOptions(options) {
      if (options.length > 0) {
        this.filterArr = _.cloneDeep(options);
        this.filterArr.forEach((item) => {
          if (item.children) {
            _.remove(item.children, function (n) {
              return n.label == "全部";
            });
          }
        });
      }
    },

    getDistrictRes(res) {
      let sourceOption = [];
      if (res.code == 0 && res.data.length > 0) {
        let resData = res.data;
        resData.forEach((item) => {
          let optionItem = {
            value: item.id,
            label: item.name,
          };
          if (item.children.length > 0) {
            let cityItems = [];
            if (item.name == "广东") {
              cityItems.push({
                value: 4400000,
                label: "全部",
              });
            } else if (item.name == "山东") {
              cityItems.push({
                value: 3700000,
                label: "全部",
              });
            }
            item.children.forEach((child) => {
              let cityItemObj = {
                value: child.id,
                label: child.name,
              };
              if (child.children.length > 0) {
                let zoneItems = [];
                child.children.forEach((childs) => {
                  let zoneItemsObj = {
                    value: childs.id,
                    label: childs.name,
                  };
                  zoneItems.push(zoneItemsObj);
                });
                cityItemObj.children = zoneItems;
              }
              cityItems.push(cityItemObj);
            });
            optionItem.children = cityItems;
          }
          sourceOption.push(optionItem);
        });
      }
      return sourceOption;
    },

    search() {
      this.convertFormData(this.searchForm);
      searchOpt(this.searchForm).then((res) => {
        console.log("search", res);
        if (res.code == 0) {
          if (res.data.length == 0) {
            this.isEmpty = true;
            this.specialList = [];
          } else {
            this.isEmpty = false;
            this.specialList = res.data;
          }
        } else {
          this.$message.error(res.info);
        }
      });
    },

    convertFormData(form) {
      if (Array.isArray(form.areaId)) {
        if (form.areaId.length > 0) {
          form.areaId = form.areaId[form.areaId.length - 1];
        } else {
          form.areaId = 0;
        }
      }
    },

    closeDialog() {
      this.areaVisible = false
      this.districtForm = {
        areaId: 0,
        status:true
      }
    },

    resetSearchForm() {
      this.$refs["specialSearch"].resetFields();
      this.search();
      this.$message.success("重置成功");
    },

    createDistrict() {
      if(!this.btnDisabled){
        let form = {};
        form.areaId =
          this.districtForm.areaId[this.districtForm.areaId.length - 1];
        form.status = this.districtForm.status ? "0" : "1";
        addOrEditDistrict(form).then((res) => {
          if (res.code == 0) {
            this.$message.success("创建成功");
            this.districtForm = {
              areaId: 0,
              status: true,
            };
            this.areaVisible = false;
            this.$refs["specialSearch"].resetFields();
            this.init();
          } else {
            this.$message.error(res.info);
          }
        });
      }
    },
    updateRegionData(){
      this.$refs["specialSearch"].resetFields();
      this.init();
    },
    initAfterEdit(){
      // this.$refs["specialSearch"].resetFields();
      this.init();
    }
  },
};
</script>

<style lang="scss" scoped>
.special_content {
  margin: auto;
  width: 100%;
  height: 90vh;
  border-radius: 12rem;
  background: #fff;
  .special_content_head {
    box-sizing: border-box;
    padding: 20rem 12rem 0rem 20rem;

    .search_form {
      display: flex;
      align-items: center;
      justify-content: space-between;
      & > div {
        display: flex;
        align-items: center;
      }
      ::v-deep .el-form-item__label {
        font-size: 14rem;
      }
    }
    .search,
    .reset,
    .create_area {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 32rem;
      background-image: var(--background-image);
      border-color: var(--primary-color);
      color: #fff;
      font-size: 14rem;
    }
    .reset{
      background: #fff;
      color:var(--primary-color);
    }

    ::v-deep .el-input__inner {
      height: 32rem;
      font-size: 14rem;
      line-height: 40rem;
    }

    ::v-deep .el-input__inner:hover,
    ::v-deep .el-input__inner:focus {
      border-color: var(--primary-color);
    }
  }
  .special_body {
    display: flex;
    flex-wrap: wrap;
    position: relative;
    overflow-y: scroll;
    overflow-x: hidden;
    height: 88%;
    .specialItem {
      margin: 10rem 0rem 20rem 20rem;
    }
    .el-empty {
      position: absolute;
      top: 26%;
      left: 40%;
    }
  }
  .areaDia {
    ::v-deep .el-dialog {
      height: 351rem;
      display: flex;
      flex-direction: column;
      margin: 0 !important;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      border-radius: 10rem;
      background: #f5f5f5;
    }
    // Dialog关闭按钮
    ::v-deep .el-dialog__headerbtn:focus .el-dialog__close,
    ::v-deep .el-dialog__headerbtn:hover .el-dialog__close {
      color: var(--primary-color) !important;
    }
    .area-content {
      display: flex;
      align-items: center;
      margin-bottom: 20rem;
      p {
        width: 50rem;
        font-size: 14rem;
      }
      ::v-deep .el-input__inner {
        height: 32rem;
      }
    }
    .save-button {
      position: absolute;
      right: 20rem;
      bottom: 20rem;
      width: 72rem;
      height: 32rem;
      line-height: 32rem;
      font-size: 14rem;
      color: #fff;
      background: var(--primary-color);
      border-radius: 4rem;
      display: flex;
      justify-content: center;
      cursor: pointer;
    }
    .diable-btn {
      background: #b7e7d3;
    }
  }

  ::v-deep .el-dialog__headerbtn {
    display: flex;
    font-size: 24rem;
  }
}
::v-deep .el-cascader .el-input.is-focus .el-input__inner {
  border-color: var(--primary-color);
}
::v-deep .el-cascader .el-input .el-input__inner:focus,
::v-deep .el-select .el-input .el-input__inner:focus,
::v-deep .el-cascader .el-input .el-input__inner:hover,
::v-deep .el-select .el-input .el-input__inner:hover,
::v-deep .el-select .el-input.is-focus .el-input__inner {
  border-color: var(--primary-color);
}
.select-popper {
  .el-select-dropdown__item.selected,
  .el-select-dropdown__item.hover {
    color: var(--primary-color);
  }
}

::-webkit-scrollbar {
  width: 8rem;
}
::-webkit-scrollbar-thumb {
  border-radius: 6rem;
  background-color: #d9d9d9;
}
.red-star-icon{
  font-size:14rem;
  color:#FF0000;
  margin-right:5rem;
  padding-top: 2rem;
}
</style>
<style lang='scss'>
.dia-title {
  display: flex;
  align-items: center;
  line-height: 14rem;
  width: 100rem;
  justify-content: space-between;
  .dia-title-before {
    width: 4rem;
    height: 16rem;
    border-radius: 2rem;
    background: var(--primary-color);
  }
  .dia-title-text {
    font-size: 18rem;
    font-weight: bold;
    width: 90rem;
  }
  font-size: 14rem;
}
</style>